/**
 * COURE.QUIZ.SERVICE.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { QuestionOptionDto } from './questionOptionDto';

export interface QuestionOptionResponse { 
    questionId?: string;
    answerOptionId?: string;
    questionText?: string;
    data?: Array<QuestionOptionDto>;
    responseMessage?: string;
}